<template>
    <card shadow type="secondary">
        <div slot="header" class="bg-white border-0">
            <div class="row align-items-center">
                <div class="col-8">
                    <h3 class="mb-0">Rechnungs- und Vertragsdaten {{ customer }}</h3>
                </div>
            </div>
        </div>
        <template>
            <b-embed v-if="fakturiaLink !== null"
                    type="iframe"
                    aspect="16by9"
                    :src="fakturiaLink"
                    allowfullscreen
            ></b-embed>
            <div v-if="isLoading"><i class="fas fa-circle-notch fa-spin"></i> Loading Billingcenter....</div>
        </template>
    </card>
</template>

<script>
    export default {
        name:"billing",
        data() {
            return {
                fakturiaLink: null,
                isLoading: true
            }
        },
        created() {
            this.$store.dispatch('customer/getCustomerCollection');
            this.getLink();
        },
        computed: {
            customer() {
                return (this.$store.getters['customer/isReady']) ? this.$store.getters['customer/showCustomerByIRI']('/api/customers/'+this.$store.getters['authentication/customer']).name : 'ID: ' + this.$store.getters['authentication/customer'];
            },
        },
        methods: {
            getLink() {
                return new Promise(() => {
                    const header = this.authHeader();
                    header['Content-Type'] = 'application/json';
                    const requestOptions = {
                        method: 'GET',
                        headers: header,
                    };
                    this.isLoading = true;
                    fetch(process.env.VUE_APP_API_SERVER + `/api/fakturia/login`, requestOptions)
                        .then(this.handleResponse)
                        .then(response => {
                                this.isLoading = false;
                                this.fakturiaLink = response.loginUrl;
                            },
                            error => {
                                this.isLoading = false;
                                this.$store.dispatch('alert/error',error);
                            });
                });
            },
        }

    }
</script>

<style scoped>

</style>